import type { CalendarDate } from "../shared/calendar-date";
import type { DiaryEntry } from "./diary-entry";
import type { NutrientProfile } from "../nutrition/nutrients";
import { addNutrients, EMPTY_NUTRIENTS } from "../nutrition/nutrients";
import { caloriesFromNutrients } from "../nutrition/energy";

export interface DailyDiarySummary {
  readonly date: CalendarDate;
  readonly nutrients: NutrientProfile;
  readonly calories: number;
  readonly entryCount: number;
}

export function summarizeDiary(date: CalendarDate, entries: readonly DiaryEntry[]): DailyDiarySummary {
  const matching = entries.filter((entry) => entry.date === date);
  const nutrients = matching.reduce((total, entry) => addNutrients(total, entry.food.nutrients), EMPTY_NUTRIENTS);
  return { date, nutrients, calories: caloriesFromNutrients(nutrients), entryCount: matching.length };
}
